import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import Skeleton from '@material-ui/lab/Skeleton'
import useStyles from './styles'

export const SCHEDULE_SKELETON_ROWS = 2

const useSkeletonStyles = makeStyles({
  row: {
    pointerEvents: 'none',
  },
})

export const ScheduleListSkeleton = ({ rows = SCHEDULE_SKELETON_ROWS }) => {
  const classes = useStyles()
  const skeletonClasses = useSkeletonStyles()

  return (
    <Box className={classes.list} data-testid="schedule-loading">
      {Array.from({ length: rows }, (_, index) => (
        <Box
          key={index}
          className={`${classes.row} ${classes.rowStatic} ${skeletonClasses.row}`}
        >
          <Box className={classes.timeColumn}>
            <Skeleton variant="text" width={56} height={18} />
            <Skeleton variant="text" width={48} height={16} />
          </Box>
          <Box className={classes.contentCluster}>
            <Skeleton variant="rect" className={classes.accentBar} />
            <Box className={classes.detailsColumn}>
              <Skeleton variant="text" width="60%" height={20} />
              <Skeleton variant="text" width="35%" height={18} />
            </Box>
          </Box>
          <Box className={classes.trailingColumn}>
            <Skeleton variant="text" width={40} height={18} />
          </Box>
        </Box>
      ))}
    </Box>
  )
}

ScheduleListSkeleton.propTypes = { rows: PropTypes.number }

// Page-level placeholder for the Today's schedule card.
const TodaysScheduleSkeleton = () => {
  const classes = useStyles()

  return (
    <Box className={classes.card} data-testid="todays-schedule-skeleton">
      <Box className={classes.header}>
        <Box>
          <Skeleton variant="text" width={140} height={21} />
          <Skeleton variant="text" width={200} height={20} />
        </Box>
      </Box>
      <ScheduleListSkeleton />
    </Box>
  )
}

export default TodaysScheduleSkeleton
